import type { FC } from 'react'

import { Heading } from '@/components'


export const RetailPage: FC = () => {
  return (
    <div style={{ padding: '24px 16px' }}>
      <Heading level={1}>Ритейл</Heading>
      <br />
      <p>Раздел в активной разработке</p>
    </div>
  )
}
